/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';

// Technology icon mapping - using Simple Icons CDN
const getTechIcon = (techName) => {
  const iconMap = {
    // AI/ML
    TensorFlow: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/tensorflow.svg',
    PyTorch: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/pytorch.svg',
    'Scikit Learn': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/scikitlearn.svg',
    OpenCV: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/opencv.svg',
    Keras: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/keras.svg',
    'Auto ML': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/googlecloud.svg',
    // Backend
    'Node.js': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/nodedotjs.svg',
    Python: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/python.svg',
    Java: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/java.svg',
    Golang: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/go.svg',
    Rust: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/rust.svg',
    // Database
    MongoDB: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/mongodb.svg',
    PostgreSQL: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/postgresql.svg',
    MySQL: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/mysql.svg',
    Firebase: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/firebase.svg',
    Memcached: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/memcached.svg',
    // DevOps
    Docker: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/docker.svg',
    Kubernetes: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/kubernetes.svg',
    AWS: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/amazonaws.svg',
    Jenkins: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/jenkins.svg',
    Git: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/git.svg',
    Jira: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/jira.svg',
    // Frontend
    'React.js': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/react.svg',
    'Angular.js': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/angular.svg',
    'Vue.js': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/vuedotjs.svg',
    JavaScript: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/javascript.svg',
    HTML: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/html5.svg',
    CSS: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/css3.svg',
    // Mobile
    'React Native': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/react.svg',
    Flutter: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/flutter.svg',
    iOS: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/ios.svg',
    Android: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/android.svg',
    Xcode: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/xcode.svg',
    'Android Studio': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/androidstudio.svg',
    // Testing
    Selenium: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/selenium.svg',
    Postman: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/postman.svg',
    'Sauce Labs': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/saucelabs.svg',
    XRay: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/xray.svg',
    'Test MO': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/testcafe.svg',
    'Cross Browser Testing': 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/browserstack.svg',
    // UI/UX
    Figma: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/figma.svg',
    Sketch: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/sketch.svg',
    Zeplin: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/zeplin.svg',
    Framer: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/framer.svg',
  };

  return iconMap[techName] || null;
};

export default function Technologies({ data }) {
  const categories = [
    { title: 'AI/ML', items: data.aiMl },
    { title: 'Backend', items: data.backend },
    { title: 'Database', items: data.database },
    { title: 'DevOps', items: data.devops },
    { title: 'Frontend', items: data.frontend },
    { title: 'Mobile', items: data.mobile },
    { title: 'Testing', items: data.testing },
    { title: 'UI/UX', items: data.uiUx },
  ];

  return (
    <section className="relative bg-gray-50 py-24 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-theme-purple/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-dark-theme-purple/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <Fade bottom>
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-2xl mb-6">
              <svg className="w-10 h-10 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
              Our Tools and Technologies
            </h2>
            <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
              Explore the powerful tools and technologies we use to build reliable solutions for our
              clients.
            </p>
          </div>
        </Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => (
            <Fade bottom delay={200 * index} key={category.title}>
              <div className="group relative bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 overflow-hidden">
                {/* Decorative gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-theme-purple/5 to-dark-theme-purple/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Corner decoration */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-theme-purple/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                <div className="relative z-10">
                  <div className="flex items-center mb-4 pb-2 border-b border-gray-200">
                    <div className="w-8 h-8 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-lg flex items-center justify-center mr-3 group-hover:from-theme-purple/20 group-hover:to-dark-theme-purple/20 transition-all duration-300">
                      <svg className="w-4 h-4 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4a2 2 0 012-2h2" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-theme-blue group-hover:text-theme-purple transition-colors duration-300">
                      {category.title}
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {category.items.map((item) => {
                      const iconUrl = getTechIcon(item);
                      return (
                        <span
                          key={item}
                          className="group/tech px-3 py-1.5 bg-gray-50 text-gray-700 text-sm rounded-lg border border-gray-200 hover:bg-theme-purple/10 hover:border-theme-purple/30 hover:text-theme-purple transition-all duration-200 flex items-center gap-1.5 transform hover:scale-105"
                        >
                          {iconUrl && (
                            <img
                              src={iconUrl}
                              alt={`${item} icon`}
                              className="w-4 h-4 object-contain group-hover/tech:scale-110 transition-transform duration-200"
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                          <span>{item}</span>
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
